import { CreditCard, LineChart, Calculator, Banknote,Building2,House,CircleDollarSign,Users,Component } from "lucide-react";

import { MenuItem } from '@/types/types';

const menuItems: MenuItem[] = [
  {
    title: "Credit Card",
    href: "/credit-card",
    icon: "",
    submenucount: 4,
    submenu: [
      {
        title: "Card Types",
        items: [
          { key: 1001, itemName: "Cash Back", href: "/cardlists?type=1",addnewhighlight :false },
          { key: 1002, itemName: "Welcome Bonus", href: "/cardlists?type=2" ,addnewhighlight :false},
          { key: 1003, itemName: "Free For Life", href: "/cardlists?type=3" ,addnewhighlight :false},
          { key: 1004, itemName: "Travel Card", href: "/cardlists?type=4" ,addnewhighlight :false},
          { key: 1005, itemName: "Premium Card", href: "/cardlists?type=5" ,addnewhighlight :false},
          { key: 1006, itemName: "Etihad Miles", href: "/cardlists?type=6" ,addnewhighlight :false},
          { key: 1007, itemName: "Emirate SkyWords", href: "/cardlists?type=7" ,addnewhighlight :false},
          { key: 1008, itemName: "Life Style", href: "/cardlists?type=21" ,addnewhighlight :false},
          { key: 1009, itemName: "Fixed Deposit", href: "/cardlists?type=9" ,addnewhighlight :false},
          { key: 1010, itemName: "Islamic Card", href: "/cardlists?type=10" ,addnewhighlight :false},
          { key: 1011, itemName: "First Year Free", href: "/cardlists?type=22" ,addnewhighlight :false},
          { key: 1099, itemName: "Emarati Cards", href: "/cardlists?type=20" ,addnewhighlight :false},
        ],
      },
      {
        title: "Top Banks",
        items: [
          { key: 1012, itemName: "FAB", href: "/cardlists?bank=FAB" ,addnewhighlight :false},
          { key: 1013, itemName: "ENBD", href: "/cardlists?bank=EMIRATESNBD" ,addnewhighlight :false},
         // { key: 1014, itemName: "ADCB", href: "/cardlists?bank=ADCB" ,addnewhighlight :false},
          // { key: 1015, itemName: "Mashreeq", href: "/cardlists?bank=MASQ" ,addnewhighlight :false},
          { key: 1016, itemName: "CBD", href: "/cardlists?bank=CBD" ,addnewhighlight :false},
          { key: 1017, itemName: "RAK Bank", href: "/cardlists?bank=RAKBANK" ,addnewhighlight :false},
          { key: 1018, itemName: "HSBC", href: "/cardlists?bank=HSBC" ,addnewhighlight :false},
          { key: 1019, itemName: "Citi Bank", href: "/cardlists?bank=CityBank" ,addnewhighlight :false},
          // { key: 1020, itemName: "Standard Chartered", href: "/cardlists?bank=STB" ,addnewhighlight :false},
          { key: 1021, itemName: "Dubai First", href: "/cardlists?bank=DubaiFirst" ,addnewhighlight :false},
          { key: 1022, itemName: "Deem Finance", href: "/cardlists?bank=DEEM" ,addnewhighlight :false},
        ],
      },
      {
        title: "Top Credit Card",
        items: [
          // { key: 1023, itemName: "Best Credit Card", href: "/cardlists?category=20" ,addnewhighlight :false},
          { key: 1024, itemName: "Best CashBack Card", href: "/cardlists?category=13" ,addnewhighlight :false},
          { key: 1025, itemName: "Best Sky words Card", href: "/cardlists?category=14" ,addnewhighlight :false},
          { key: 1026, itemName: "Best Movie offer Card", href: "/cardlists?category=15" ,addnewhighlight :false},
          { key: 1027, itemName: "Best Travle Card", href: "/cardlists?category=19" ,addnewhighlight :false},
          { key: 1028, itemName: "Best Dining Offer Card", href: "/cardlists?category=17" ,addnewhighlight :false},
          { key: 1029, itemName: "Best Life Style Card", href: "/cardlists?category=18" ,addnewhighlight :false},
          // { key: 1030, itemName: "Skywards Miles", href: "/skywards-miles" },
          // { key: 1031, itemName: "Etihad Miles", href: "/etihad-miles-feature" },
          // { key: 1032, itemName: "High Credit Limit", href: "/high-credit-limit" },
          // { key: 1033, itemName: "Exclusive For UAE Citizens", href: "/exclusive-uae-citizens" },
        ],
      },
      {
        title: "Credit Card Utilities",
        items: [
          { key: 1034, itemName: "DBR Calculator", href: "/dbr-check" ,addnewhighlight :true},
          { key: 1035, itemName: "Compare Card", href: "/cardcompare" ,addnewhighlight :true},
          { key: 1069, itemName: "Credit Card In UAE", href: "/creditcards" ,addnewhighlight :true},
        ],
      },
    ],
  },
  {
    title: "Personal Loan",
    href: "/loan",
    icon: "",
    submenucount: 2,
    submenu: [
      {
        title: "Loan Types",
        items: [
          { key: 1036, itemName: "Salary Transfer Loan", href: "/loan/loantype/salary-transfer-loan" ,addnewhighlight :false},
          { key: 1037, itemName: "Buy Out Loan", href: "/loan/loantype/buy-out-loan" ,addnewhighlight :false},
          { key: 1038, itemName: "Loan Without Salary Transfer", href: "/loan/loantype/loan-without-salary-transfer" ,addnewhighlight :false},
          { key: 1039, itemName: "Loan For Non Listed Company", href: "/loan/loantype/loan-for-non-listed-company" ,addnewhighlight :false},
          { key: 1040, itemName: "Loan For New to Country/Company", href: "/loan/loantype/loan-for-new-to-country-company" ,addnewhighlight :false},
          { key: 1041, itemName: "Emirati/UAE National Loan", href: "/loan/loantype/emirati-uae-national-loan" ,addnewhighlight :false},
          { key: 1042, itemName: "Islamic Finance", href: "/loan/loantype/islamic-finance" ,addnewhighlight :false},
          { key: 1043, itemName: "SME Business Loan", href: "/loan/loantype/sme-business-loan" ,addnewhighlight :false},
        ],
      },
      {
        title: "Features Type",
        items: [
          { key: 1044, itemName: "Best Personal Loan Deal", href: "/loan" ,addnewhighlight :false},
          { key: 1045, itemName: "Best Interest Rate", href: "/loan" ,addnewhighlight :false},
          { key: 1046, itemName: "Quick Approval", href: "/loan" ,addnewhighlight :false},
          { key: 1047, itemName: "Digital Process", href: "/loan" ,addnewhighlight :false},
          { key: 1048, itemName: "Instant Personal Loan", href: "/loan" ,addnewhighlight :false},
        ],
      },
      {
        title: "Utilities",
        items: [
          { key: 1073, itemName: "EMI Calculator", href: "/loan/calculator/emi-page" ,addnewhighlight :true},
          { key: 1074, itemName: "Compare Lone", href: "/loan" ,addnewhighlight :true},
          { key: 1075, itemName: "Bank Swift Codes", href: "/loan" ,addnewhighlight :true},
          { key: 1076, itemName: "Loan In UAE", href: "/loan" ,addnewhighlight :true},
        ],
      },
    ],
  },
  {
    title: "Bank Account",
    href: "/bankaccounts",
    icon: "",
    submenucount: 3,
    submenu: [
      {
        title: "Account Types",
        items: [
           { key: 1049, itemName: "Current Account", href: "/bankaccounts/accounttype/current-account" ,addnewhighlight :false},
           { key: 1050, itemName: "Savings Account", href: "/bankaccounts/accounttype/savings-account" ,addnewhighlight :false},
           { key: 1051, itemName: "Salary Transfer Account", href: "/bankaccounts/accounttype/salary-transfer-account" ,addnewhighlight :false},
           { key: 1052, itemName: "Zero Balance Account", href: "/bankaccounts/accounttype/zero-balance-account" ,addnewhighlight :false},
           { key: 1053, itemName: "Digital Account", href: "/bankaccounts/accounttype/digital-account" ,addnewhighlight :false},
           { key: 1054, itemName: "Premium/Priority Account", href: "/bankaccounts/accounttype/premium-priority-account" ,addnewhighlight :false},
           { key: 1055, itemName: "Deposit Account", href: "/bankaccounts/accounttype/deposit-account" ,addnewhighlight :false},
           { key: 1056, itemName: "Business/SME Account", href: "/bankaccounts/accounttype/business-sme-account" ,addnewhighlight :false},
           { key: 1057, itemName: "Offshore Account", href: "/bankaccounts/accounttype/offshore-account" ,addnewhighlight :false},
        ],
      },
      {
        title: "Features",
        items: [
           { key: 1058, itemName: "Best Salary Account Deal", href: "/bankaccounts/features?feature=best-salary-account-deal" ,addnewhighlight :false},
           { key: 1059, itemName: "Best Current Account", href: "/bankaccounts/features?feature=best-current-account" ,addnewhighlight :false},
           { key: 1060, itemName: "Best Deposit Account", href: "/bankaccounts/features?feature=best-deposit-account",addnewhighlight :false },
        ],
      },
      {
        title: "Utilities",
        items: [
          { key: 1061, itemName: "Latest Bank Account Offers", href: "/bankaccounts/offers", addnewhighlight: true },
           { key: 1077, itemName: "Account In UAE", href: "/bankaccounts", addnewhighlight: true },
        ],
      },
     
    ],
  },
  {
    title: "Corporate & SME",
    icon: "",
    submenucount: 1,
    submenu: [
      {
        title: "Features",
        items: [
          { key: 1069, itemName: "Corporate & SME Banking Services", href: "/corporatesme" ,addnewhighlight :false},
          { key: 1070, itemName: "Corporate & SME Investment", href: "/corporatesme" ,addnewhighlight :false},
          { key: 1071, itemName: "Corporate & SME Loan", href: "/corporatesme" ,addnewhighlight :false},
          { key: 1072, itemName: "Corporate & SME Account", href: "/corporatesme" ,addnewhighlight :false},
        ],
      },
    ],
  },
  {
    title: "Mortgage",
    icon: "",
    submenucount: 1,
    submenu: [
      {
        title: "Calculators",
        items: [
          { key: 1061, itemName: "Best Mortgage Providers", href: "/mortgageservices" ,addnewhighlight :false},
          { key: 1062, itemName: "Mortgage Calculator", href: "/mortgageservices" ,addnewhighlight :false},
          { key: 1063, itemName: "Mortgage Eligibility", href: "/mortgageservices" ,addnewhighlight :false},
          { key: 1064, itemName: "Mortgage For Expats", href: "/mortgageservices",addnewhighlight :false },
        ],
      },
    ],
  },
  {
    title: "NRI",
    icon: "",
    submenucount: 1,
    submenu: [
      {
        title: "Features",
        items: [
          { key: 1065, itemName: "NRI Banking Services", href: "/nriservices" ,addnewhighlight :false},
          { key: 1066, itemName: "NRI Investment", href: "/nriservices" ,addnewhighlight :false},
          { key: 1067, itemName: "NRI Loan", href: "/nriservices" ,addnewhighlight :false},
          { key: 1068, itemName: "NRI Account", href: "/nriservices" ,addnewhighlight :false},
        ],
      },
    ],
  },
   {
    title: "Referral Portal",
    icon: "",
    href: "/referral",
    submenucount: 0,
  },
];

export default menuItems;
